var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavesRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 288,
    viewBox: "0 0 249 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2332 349.704C95.2332 323.204 105.233 269.504 161.233 266.704C231.233 263.204 257.233 219.704 249.233 190.204C241.233 160.704 256.733 110.704 296.733 90.2044C336.733 69.7044 349.233 71.2044 356.733 80.7044",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4575 341.394C6.62418 310.973 14.8783 248.39 86.5619 241.423C176.166 232.714 194.666 183.826 189.979 149.764C185.291 115.703 197.812 41.5199 259.118 31.9402C314.829 20.8599 333.391 9.74412 340.917 10.7275",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesRight);
export default __webpack_public_path__ + "static/media/waves-right.b7cb0770fff9efc27cbd0ec8da1a0efa.svg";
export { ForwardRef as ReactComponent };